import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../home/components/TrustBar';
import WhyChooseUs from '../home/components/WhyChooseUs';
import Testimonials from '../home/components/Testimonials';
import ServiceAreas from '../home/components/ServiceAreas';
import ProcessTimeline from '../home/components/ProcessTimeline';
import MidCTA from '../home/components/MidCTA';
import Gallery from '../home/components/Gallery';
import LeadForm from '../home/components/LeadForm';
import MobileCallButton from '../home/components/MobileCallButton';
import ServicesHero from './components/ServicesHero';
import ServicesFull from './components/ServicesFull';
import ServicesFAQ from './components/ServicesFAQ';

export default function ServicesPage() {
  return (
    <main>
      <Navbar />
      <ServicesHero />
      <TrustBar />
      <ServicesFull />
      <WhyChooseUs />
      <Testimonials />
      <MidCTA />
      <ServiceAreas />
      <ProcessTimeline />
      <ServicesFAQ />
      <Gallery />
      <LeadForm />
      <Footer />
      <MobileCallButton />
    </main>
  );
}
